import { main, app } from '../constants';

const initialState = {
  locators: ['ALL'],
  machineData: [],
  locatorFilter: 'ALL',
  highlightedMachine: null,
  openMachine: null,
  openMachineSelectedJob: null,
  insertJobType: 'DYNAMIC',
  locationData: new Map(),
  notesModalCb: null,
  notesInitValue: null,
  timelineViewType: 'PART',
  timelineTextFilter: '',
  weekFilter: 'NONE',
};

export default (state = initialState, action) => {
  if(action.type === main.LOGOUT) return initialState;
  if(action.type === app.UPDATE_LOCATORS) return {
    ...state,
    locators: action.data,
  };
  if(action.type === app.UPDATE_MACHINE_DATA) return {
    ...state,
    machineData: action.data,
  };
  if(action.type === app.UPDATE_LOCATOR_FILTER) return {
    ...state,
    locatorFilter: action.data,
  };
  if(action.type === app.UPDATE_HIGHLIGHTED_MACHINE) return {
    ...state,
    highlightedMachine: action.data,
  };
  if(action.type === app.UPDATE_OPEN_MACHINE) return {
    ...state,
    openMachine: action.data,
  };
  if(action.type === app.UPDATE_OPEN_MACHINE_SELECTED_JOB) return {
    ...state,
    openMachineSelectedJob: action.data,
  };
  if(action.type === app.UPDATE_INSERT_JOB_TYPE) return {
    ...state,
    insertJobType: action.data,
  };
  if(action.type === app.UPDATE_LOCATION_DATA) return {
    ...state,
    locationData: action.data,
  };
  if(action.type === app.UPDATE_NOTES_MODAL_CB) return {
    ...state,
    notesModalCb: action.data,
  };
  if(action.type === app.UPDATE_NOTES_INIT_VALUE) return {
    ...state,
    notesInitValue: action.data,
  };
  if(action.type === app.UPDATE_TIMELINE_VIEW_TYPE) return {
    ...state,
    timelineViewType: action.data,
  };
  if(action.type === app.UPDATE_TIMELINE_TEXT_FILTER) return {
    ...state,
    timelineTextFilter: action.data,
  };
  if(action.type === app.UPDATE_WEEK_FILTER) return {
    ...state,
    weekFilter: action.data,
  };
  return state;
};
